import { Alert, Snackbar, Typography, useTheme } from "@mui/material";
import SuccessIcon from "@/assets/icons/notification/success.svg?react";
import Attention from "@/assets/icons/notification/attention.svg?react";
import { NotificationProps } from "./types";

const Notification = ({
  open,
  title,
  description,
  onClose,
  severity = "success",
}: NotificationProps) => {
  const theme = useTheme();
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
    >
        <Alert onClose={onClose} icon={severity === "error" ? <Attention /> : <SuccessIcon />} severity={severity}>
        <Typography
          sx={{
            fontWeight: "700",
            fontSize: { sm: "1rem", md: "1.125rem" },
            ...(description ? { marginBottom: "8px" } : null),
          }}
        >
          {title}
        </Typography>
        {description ? (
          <Typography
            sx={{
              fontSize: { sm: "0.875rem", md: "1rem" },
              color: theme.palette.text.secondary,
            }}
          >
            {description}
          </Typography>
        ) : null}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
